export const salesMenus = () => ({
    id: `main-menu-2-all`,
    path: '/management/sales/crm/contacts',
    label: 'Sales',
    isEnabled: true,
    svg: (
        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M5 10.5a.5.5 0 0 1 .5-.5H7v-3a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v3h1.5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5H5.5a.5.5 0 0 1-.5-.5v-9zm9-5a3.5 3.5 0 0 1 0 7 3.5 3.5 0 0 1 0-7zm-6 9h8v-2H8v2zm0 3h8v-2H8v2z" />
            </g>
        </svg>

    ),

    Description: 'Sales encompass a wide range of operations and activities aimed at effectively promoting, marketing, and selling goods or services to customers, ensuring business growth and customer satisfaction.',
    subMenu: [
        {
            id: `coln-1-collections`,
            label: 'CRM',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M12 2a5 5 0 0 0-5 5v1a5 5 0 0 0 5 5 5 5 0 0 0 5-5V7a5 5 0 0 0-5-5zm-1 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM4 14a8 8 0 0 0 16 0H4zm0 2a6 6 0 0 1 12 0H4z" />
                </svg>
            ),
            path: '/management/sales/crm/contacts',
            isEnabled: true,
  subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Contacts',
                    path: '/management/sales/crm/contacts',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                            <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                            <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                        </svg>
                    ),
                },
                 {
                    id: `coln-1-collections`,
                    label: 'Leads',
                    path: '/management/sales/crm/leads',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                            <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                            <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                        </svg>
                    ),
                },
                 {
                    id: `coln-1-collections`,
                    label: 'Tasks',
                    path: '/management/sales/crm/tasks',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                            <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                            <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                        </svg>
                    ),
                },
                 {
                    id: `coln-1-collections`,
                    label: 'Opportunities',
                    path: '/management/sales/crm/opportunities',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                            <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                            <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                        </svg>
                    ),
                },
                 {
                    id: `coln-1-collections`,
                    label: 'Customers',
                    path: '/management/sales/crm/customers',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                            <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                            <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                        </svg>
                    ),
                },
                 {
                    id: `coln-1-collections`,
                    label: 'Sales Quotes',
                    path: '/management/sales/crm/salesquotes',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                            <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                            <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                        </svg>
                    ),
                },
                 {
                    id: `coln-1-collections`,
                    label: 'Sales Orders',
                    path: '/management/sales/crm/salesorders',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                            <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                            <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                        </svg>
                    ),
                },
                
            ],
        },
        {
            id: `coln-1-collections`,
            label: 'SRM',
            svg: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-4 w-4 mr-1" fill="#007BFF">
                    <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 22c-5.524 0-10-4.476-10-10S6.476 2 12 2s10 4.476 10 10-4.476 10-10 10zm-1-15h-2v2h2v-2zm0 4h-2v2h2v-2zm5 1h-2v2h2v-2zm2-4h-2v2h2V8zm-3 7h-2v2h2v-2zM8 12H6v2h2v-2z" />
                </svg>

            ),
            path: '/management/sales/srm/evaluations',
            isEnabled: true,

            subMenu: [
                 {
                    id: `coln-1-collections`,
                    label: 'Evaluations',
                    path: '/management/sales/srm/evaluations',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                            <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                            <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                        </svg>
                    ),
                },
            ]

        },
        {
            id: `coln-1-Categories`,
            label: 'PRM',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M4 4v4h4V4H4zm0 6v4h4v-4H4zm6-6v4h4V4h-4zm0 6v4h4v-4h-4zm6-6v4h4V4h-4zm0 6v4h4v-4h-4z" />
                </svg>

            ),
            path: '/management/sales/prm',
            isEnabled: true,
        },

    ],
}
)
